import { mapGetters } from 'vuex';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  mixins: [hasPermissionMixin],
  computed: {
    ...mapGetters({
      listPermissionsGetAccount: 'accounts/getAccount',
      listPermissionsAccountId: 'getCurrentAccountId',
    }),
    listsNewRulesEnabled() {
      return !!this.listPermissionsGetAccount(this.listPermissionsAccountId)
        ?.features?.new_rules_system;
    },
    canCreateList() {
      return this.hasCreatePermission('Lists');
    },
    canEditList() {
      return this.hasEditPermission('Lists');
    },
    canDeleteList() {
      return this.hasDeletePermission('Lists');
    },
    canExportList() {
      return !this.listsNewRulesEnabled || this.hasReadPermission('Lists');
    },
    canManageListMembers() {
      return this.hasEditPermission('Lists');
    },
    canManageBlockList() {
      return (
        this.canManageListMembers &&
        (!this.listsNewRulesEnabled || this.hasEditPermission('Contacts'))
      );
    },
    disabledActionHint() {
      return this.$t('LISTS_PAGE.MEMBERS.DISABLED_ACTION_HINT');
    },
  },
};
